var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareArrow = function SvgShareArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 2",
    d: "M12 8 0 16V0Z",
    fill: "#363639"
  })));
};
export { SvgShareArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDEyIDE2Ij4NCiAgPHBhdGggaWQ9IlBvbHlnb25fMiIgZGF0YS1uYW1lPSJQb2x5Z29uIDIiIGQ9Ik04LDBsOCwxMkgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIpIHJvdGF0ZSg5MCkiIGZpbGw9IiMzNjM2MzkiLz4NCjwvc3ZnPg0K";